<template>
  <div class="field-group" :class="{ 'field-group-full': fullWidth }">
    <label class="field-label-compact" :for="id">{{ label }}</label>
    <WidgetNativeSelect
      v-if="native"
      :id="id"
      :model-value="modelValue"
      :options="options"
      :placeholder="placeholder"
      :disabled="loading || disabled"
      @update:model-value="emit('change', $event)"
    />
    <el-select
      v-else
      :model-value="modelValue"
      :placeholder="placeholder"
      class="field-select-compact premium-select"
      :loading="loading"
      :disabled="disabled"
      size="large"
      :filterable="filterable"
      teleported
      popper-class="widget-select-dropdown premium-dropdown"
      :popper-options="selectPopperOptions"
      @change="emit('change', $event)"
    >
      <el-option
        v-for="option in options"
        :key="option.value"
        :label="option.label"
        :value="option.value"
      />
    </el-select>
  </div>
</template>

<script setup lang="ts">
import WidgetNativeSelect, {
  type NativeSelectOption,
} from '@/components/widget/WidgetNativeSelect.vue';
import { selectPopperOptions } from './selectPopperOptions';

withDefaults(
  defineProps<{
    id: string;
    label: string;
    placeholder: string;
    modelValue: string | number | null;
    options: NativeSelectOption[];
    /** Render the OS-native select instead of Element Plus (touch-like devices). */
    native: boolean;
    loading?: boolean;
    disabled?: boolean;
    filterable?: boolean;
    fullWidth?: boolean;
  }>(),
  { loading: false, disabled: false, filterable: false, fullWidth: false },
);

const emit = defineEmits<{ change: [value: string | number | null] }>();
</script>

<style scoped src="./fields.css"></style>
